import React from "react";
import {BrowserRouter, Navigate, Route, Routes as Switch} from "react-router-dom";

import {PrivateRoute} from "../components/Routing";

import Layout from "../components/Layout";
import NotFound from "../pages/NotFound/NotFound";
import Auth from '../pages/Auth'
import Main from "../pages/Main/index";
import NewChat from "../pages/NewChat";
import Messages from "../pages/Messages";
import Landing from "../pages/Landing";

export default function Routes() {
    return (
        <BrowserRouter>
            <Switch>
                <Route path='/main' element={<Landing />}/>
                <Route path='/auth' element={<Auth />}/>
                <Route element={<PrivateRoute />}>
                    <Route path="/" element={<Layout />}>
                        <Route index element={<Main />}/>
                        <Route path="/messages" element={<Messages />}/>
                        <Route path="/chat/new" element={<NewChat />}/>
                        <Route path="/chat/:newchatid" element={<NewChat />}/>
                        <Route path="/notFound" element={<NotFound />}/>
                    </Route>
                </Route>
                <Route path="*" element={<Navigate to = '/notFound' replace />}/>
            </Switch>
        </BrowserRouter>
    );
}